import { Controller } from "@hotwired/stimulus"

// Controls age number input visibility based on selected age unit
export default class extends Controller {
  static targets = ["unitRadio", "numberSection", "numberInput"]

  unitChanged() {
    const selected = this.unitRadioTargets.find(r => r.checked)
    if (!selected) return

    const needsNumber = selected.value === "years" || selected.value === "months"

    if (needsNumber) {
      this.numberSectionTarget.classList.remove("hidden")
    } else {
      this.numberSectionTarget.classList.add("hidden")
      this.numberInputTarget.value = ""
    }
  }
}
